import { useTranslation } from 'next-i18next';
import { MouseEventHandler } from 'react';
import type { Market } from '@bridebook/toolbox/src/gazetteer';
import AppBadge from '@bridebook/web/app-shared/components/app-badge/app-badge';

interface IProps {
  market: Market;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

const FooterAppBadges = ({ market, onClick }: IProps) => {
  const { t } = useTranslation('common');

  return (
    <div className="bcbadges">
      {t('footer.getApp.subheading')}
      <AppBadge market={market} variant="withQrCode" onClick={onClick} />
    </div>
  );
};

export default FooterAppBadges;
